module.exports = __webpack_public_path__ + "img/type.1e26b2e5.png";